import { BarChart3, Coins, FileStack, Landmark, Layers, PieChart, Wallet } from "lucide-react";

// تبويبات التقارير المالية — أضف تقريراً جديداً بمدخل واحد هنا.
export const ACCT_REPORT_TABS = [
  { key: "income", icon: BarChart3 },
  { key: "balance", icon: Landmark },
  { key: "cashflow", icon: Wallet },
  { key: "aging", icon: Coins },
  { key: "equity", icon: PieChart },
  { key: "segments", icon: Layers },
  { key: "exports", icon: FileStack },
];

export const ACCT_REPORT_KEYS = ACCT_REPORT_TABS.map((tab) => tab.key);
